//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

export const CAMPAIGN_SUPPORT_EMAIL = 'campaignsupport@bazaarvoice.com';
